import { render, staticRenderFns } from "./counters.vue?vue&type=template&id=2d211198&scoped=true"
import script from "./counters.vue?vue&type=script&lang=js"
export * from "./counters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d211198",
  null
  
)

export default component.exports